import React, {useEffect, useState} from 'react';
import {IonContent, IonPage} from '@ionic/react';
import {useHistory} from 'react-router-dom';
import ContactCard from './ContactCard';
import {ApiService} from "../api/ApiService";
import {ContactsInfo} from "../api/model/Contacts";
import LoadDetailHeader, {useTransparentHeaderContrast} from '../components/LoadDetailHeader';
import { useLogPageVisit } from '../utils/logPageVisit';

const KeyContacts: React.FC = () => {
    useLogPageVisit('LP Key Contacts', 'User viewed the Key Contacts page');
    const history = useHistory();
    const {onSheet, onIonScroll} = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);
    const [contacts, setContacts] = useState<Record<string, ContactsInfo[]>>({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    const loadContacts = () => {
        setLoading(true);
        setError(false);
        ApiService.getContacts('keyContacts', {category: 'keyContacts', isLp: 1}).then(it => {
            const contacts: Record<string, ContactsInfo[]> = {};
            it.forEach(contact => {
                contacts[contact.subcategory] = (contacts[contact.subcategory] || []).concat(contact);
            });
            setContacts(contacts);
        }).catch(() => {
            setError(true);
        }).finally(() => setLoading(false));
    }

    useEffect(() => {
        loadContacts();
    }, []);

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/Home');
    };

    const groups = Object.keys(contacts);

    return (
        <IonPage>
            <LoadDetailHeader title="Key Contacts" onBack={goBack} onSheet={onSheet} />
            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
                <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                    <div className="home-hero advance-hero">
                        <div className="advance-hero__eyebrow">Directory</div>
                        <div className="advance-hero__title home-display">Key Contacts</div>
                        <div className="advance-hero__meta">Important numbers at a glance</div>
                    </div>

                    <div className="home-sheet contacts-sheet">
                        {error ? (
                            <div className="contacts-empty contacts-empty--card">
                                Unable to load contacts. Please check your connection and try again.
                                <div>
                                    <button type="button" className="training-secondary-btn" onClick={loadContacts}>Retry</button>
                                </div>
                            </div>
                        ) : groups.length === 0 ? (
                            <div className="contacts-empty">{loading ? 'Loading contacts…' : 'No contacts found.'}</div>
                        ) : (
                            groups.map(key => (
                                <section key={key} className="contacts-group">
                                    <div className="home-section-label">{key}</div>
                                    <div className="contacts-group__list">
                                        {contacts[key].map((val, index) => (
                                            <ContactCard key={`${key}-${val.id || index}`} contact={val} />
                                        ))}
                                    </div>
                                </section>
                            ))
                        )}
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default KeyContacts;
